module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('page-title', {
    attrs: {
      "moduleIdentifier": "tikTokShop",
      "title": _vm.$t('tikTokShop.account.label')
    }
  }, [_c('div', {
    staticClass: "btnGroup",
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "btn btn--info btn--outline",
    class: {
      'is-active': !_vm.tikTokShopAccount.active
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false)
      }
    }
  }, [_vm._v("\n          Inativo\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--info btn--outline",
    class: {
      'is-active': _vm.tikTokShopAccount.active
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(true)
      }
    }
  }, [_vm._v("\n          Ativo\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, [_c('div', {
    staticClass: "l-col-3@md img-account"
  }, [(_vm.tikTokShopAccount.logo) ? _c('img', {
    attrs: {
      "src": _vm.tikTokShopAccount.logo
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.tikTokShopAccount.logo) ? _c('i', {
    staticClass: "icon-image2 no-photo"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "l-col-9@md"
  }, [_c('panel', {
    attrs: {
      "title": "Dados da conta"
    }
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Nome:")]), _vm._v(" " + _vm._s(_vm.tikTokShopAccount.nickname))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('panel', {
    attrs: {
      "title": "Autenticação"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "hint hint--left btn",
    attrs: {
      "data-label": "Renovar token"
    },
    on: {
      "click": _vm.refreshToken
    }
  }, [_c('i', {
    staticClass: "icon-sync icon-loop2"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Token de acesso:")]), _vm._v(" " + _vm._s(_vm.tikTokShopAccount.accessToken))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Token de renovação:")]), _vm._v(" " + _vm._s(_vm.tikTokShopAccount.refreshToken))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Data de expiração:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.tikTokShopAccount.expirationDate.replace('.000Z', ''), 'DD/MM/YYYY HH:mm')))])])], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be7717f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MarketplaceAccount/TikTokShop/Edit.vue
// module id = 3415
// module chunks = 0